import React, {useContext, useState, useEffect} from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import DatosUsuario from './DatosUsuario';
import PlayList from './PlayList';
import Eventos from './Eventos';
import MiMultimedia from './MiMultimedia';
import ListaUsuarios from './ListaUsuarios';
import Votacion from './Votacion';
import VotoInstagram from './VotoInstagram';
import Sorteos from './Sorteos';
import SorteoForm from './SorteoForm';
import ListaMensajesTemplates from './ListaMensajesTemplates';
import MensajeTemplateForm from './MensajeTemplateForm';
import ListaMensajes from './ListaMensajes';
import MensajeForm from './MensajeForm';
import Pedidos from './Pedidos';
import Mensajeria from './Mensajeria';
import EventoForm from './EventoForm';
import EventoShow from './EventoShow';
import ConfirmacionWhatsapp from './ConfirmacionWhatsapp';


const ImmUsuario = () => {
  const navigate = useNavigate();
  let { area } = useParams();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  // useEffect(() => {
  //   if(authInformation.autenticado === true){
  //   }
  // }, [authInformation]);

  return (
    <div className="container-fluid">
      <div className='mb-3'>
        <nav className="navbar navbar-expand-lg border-bottom bg-white">
          <div className="container-fluid">
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <div className="navbar-nav me-auto"></div>
              <ul className="navbar-nav d-flex text-end">

                { (authInformation.rol === "Organizador" || authInformation.rol === "Admin") && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link" to={`/cl/eventos`}>Eventos</Link>
                    </li>
                    { authInformation.rol === "Admin" && (
                      <>
                        <li className="nav-item">
                          <Link className="nav-link" to={`/cl/sorteos`}>Sorteos</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to={`/cl/usuarios`}>Usuarios</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to={`/cl/pedidos`}>Pedidos</Link>
                        </li>
                      </>
                    )}
                    <li className="nav-item">
                      <Link className="nav-link" to={`/cl/multimedia`}>Multimedia</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to={`/cl/votacion`}>Votación</Link>
                    </li>
                    <li className="nav-item">
                      <Link target="_blank" className="nav-link" to={`/galeria-multimedia`}>Galeria Multimedia</Link>
                    </li>
                  </>
                )}
                <li className="nav-item">
                  <Link className="nav-link" to={`/cl/usuario`}>Datos Personales</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`/logout`}>Salir</Link>
                </li>

              </ul>
            </div>

          </div>
        </nav>
        <div className=''>
          { area === 'usuario' && <DatosUsuario /> }
          { area === 'playlist' && <PlayList /> }
          { area === 'eventos' && <Eventos /> }
          { area === 'multimedia' && <MiMultimedia /> }
          { area === 'pedidos' && <Pedidos /> }
          { area === 'votacion' && <Votacion/> }
          { area === 'voto-instagram' && <VotoInstagram /> }
          { area === 'usuarios' && <ListaUsuarios /> }
          { area === 'confirmacion-whatsapp' && <ConfirmacionWhatsapp /> }

          { area === 'usuarioForm' && <DatosUsuario /> }

          { area === 'eventoForm' && <EventoForm /> }
          { area === 'evento' && <EventoShow /> }

          { area === 'sorteos' && <Sorteos /> }
          { area === 'sorteoForm' && <SorteoForm /> }

          { area === 'mensajeria' && <Mensajeria /> }
          { area === 'lista-mensajes-template' && <ListaMensajesTemplates /> }
          { area === 'mensaje-template' && <MensajeTemplateForm /> }
          { area === 'lista-mensajes' && <ListaMensajes /> }
          { area === 'mensaje' && <MensajeForm /> }

        </div>

      </div>
    </div>
  );
};

export default ImmUsuario;